/**
 * Make an extra space (offset) for the caret to be displayed
 */
export var getOffset = function getOffset(position) {
  switch (position) {
    case 'top':
      return {
        top: -4
      };

    case 'bottom':
      return {
        top: 4
      };

    case 'left':
      return {
        left: -4
      };

    case 'right':
      return {
        left: 4
      };

    default:
      return {};
  }
};